import React from "react";

import "./score_table_block.scss";
import { observer } from "mobx-react-lite";
import CupScoreTable from "./score_table/score_table";
import cupStore from "../../../stores/cup_store/cup_store";

function CupScoreTableBlock() {
	return (
		<div className="score_table_block">
			<div className="title">Турнирная таблица</div>
			<div className="tables_wrapper">
				{cupStore.scoreTables &&
					cupStore.scoreTables.map((table, index) => (
						<div className="table_wrapper" key={index}>
							<CupScoreTable table={table}></CupScoreTable>
						</div>
					))}
			</div>
		</div>
	);
}

export default observer(CupScoreTableBlock);
